export default __webpack_public_path__ + "static/media/notessvg.4b75fc48.svg";